import React, { Component } from 'react';
import { Link } from 'react-router';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';

class Header extends Component {

  render() {

    return (
      <nav className="navbar navbar-fixed-top hidden-xs">
        <div className="container-fluid">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <div className="col-sm-12">
              <Link className="navbar-brand musti-black-logo" to={"/"}></Link>
            </div>
          </div>
          { /*<div id="navbar" className="navbar-collapse collapse">
            <form className="navbar-form navbar-right">
              <button type="submit" className="btn trimmis-button">Sign in</button>
            </form>
          </div> */}
        </div>
      </nav>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ../components/Header.js